module.exports = __webpack_public_path__ + "static/media/1.38a2a4ef.svg";